import React from 'react';

export const AnalyzeEventCases = () => <h1 className="pageTitle">Event Cases</h1>;
